/*** IMPORTS FROM imports-loader ***/
var widgetFactory = require("src/radio");

var registerCustomElement = require('@dojo/widget-core/registerCustomElement').default;

var defaultExport = widgetFactory.default;
defaultExport && registerCustomElement(defaultExport);




//////////////////
// WEBPACK FOOTER
// ./node_modules/imports-loader?widgetFactory=src/radio!./node_modules/@dojo/cli-build-widget/template/custom-element.js
// module id = ./node_modules/imports-loader/index.js?widgetFactory=src/radio!./node_modules/@dojo/cli-build-widget/template/custom-element.js
// module chunks = radio